import { FC } from 'react'
import { DefaultProps } from '../../common'

type AlertSuccessIconProps = DefaultProps & {
  width?: number
  height?: number
}

export const AlertSuccessIcon: FC<AlertSuccessIconProps> = ({
  className,
  id,
  testId,
  ariaLabel,
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(!ariaLabel ? { 'aria-hidden': true, role: 'presentation' } : {})}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.3" cx="20" cy="20" r="20" fill="#68FC97" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 19.75C10 14.3652 14.3652 10 19.75 10C25.1348 10 29.5 14.3652 29.5 19.75C29.5 25.1348 25.1348 29.5 19.75 29.5C14.3652 29.5 10 25.1348 10 19.75ZM23.3603 17.9359C23.6011 17.5989 23.523 17.1305 23.1859 16.8897C22.8489 16.6489 22.3805 16.727 22.1397 17.0641L18.9043 21.5936L17.2803 19.9697C16.9874 19.6768 16.5126 19.6768 16.2197 19.9697C15.9268 20.2626 15.9268 20.7374 16.2197 21.0303L18.4697 23.2803C18.6256 23.4362 18.8421 23.5156 19.0619 23.4974C19.2816 23.4793 19.4822 23.3653 19.6103 23.1859L23.3603 17.9359Z"
        fill="#1EBF51"
      />
    </svg>
  )
}
